export default __webpack_public_path__ + "static/media/hetimenu_gomb.812eb66d.png";